<div class="modal-body width-500">
  <div class="layout-auto-1-auto">
    <h5 *ngIf="!data.isEdit" class="modal-header">{{getRessource('ModalHeaderCreate')}}</h5>
    <h5 *ngIf="data.isEdit" class="modal-header">{{getRessource('ModalHeaderEdit')}}</h5>
    <div class="content modal-form height-400">
      <form #inputForm="ngForm">
        <ng-container *ngIf="!isLoading">
          <exg-input [required]="true" [maxlength]="256" [caption]="getRessource('InputName')" name="qverName" [(ngModel)]="dataModelClone.qverName"></exg-input>
          <exg-textarea [maxlength]="2048" [caption]="getRessource('InputDescription')" name="qverDescription" [(ngModel)]="dataModelClone.qverDescription"></exg-textarea>
          <!--Status-->
          <app-exg-select-enumeration [value]="dataModelClone.qverQuestionnaireVersionStatus_enmIdent"
                                      listDisplay="enmText"
                                      (valueChange)="changeStateEnum($event)"
                                      [caption]="getRessource('InputStatus')"
                                      enumerationName="QuestionnaireVersionStatus"
                                      class="span-6">
          </app-exg-select-enumeration>
        </ng-container>
        <ng-container *ngIf="isLoading">
          <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
        </ng-container>
      </form>
    </div>
    <div class="spawn-modal-actions">
      <button class="md-btn" [disabled]="isLoading" (click)="cancelModalContext()">{{getGlobal('Cancel')}}</button>
      <button class="md-btn" [disabled]="inputForm.invalid || isLoading" (click)="saveModalContext()">{{getGlobal('Save')}}</button>
    </div>
  </div>
</div>
